import {withTable} from './withTable';
import {TableStyle} from './TableStyle';

/**
 * Data table to display sets of data.
 *
 * @component
 */
export const Table = withTable(TableStyle);
